/* eslint-disable no-shadow */

enum SitterCardVariantTypes {
  Base,
  Small,
}

export default SitterCardVariantTypes;
